<div class="relative">
  <div
    *ngIf="item.isFlagged"
    class="absolute top-0 left-0 right-0 bottom-0 z-[1] backdrop-blur-[5px]"
  >
    <div class="flex flex-col items-center translate-y-1/3 h-full">
      <ark-lib-icon-name name="flagged"></ark-lib-icon-name>
      <div class="w-full bg-pink-600 mt-[18px]">
        <div
          class="text-center text-white text-[11px] font-bold uppercase leading-[18px] tracking-wide"
        >
          Reported as illegal content
        </div>
      </div>
    </div>
  </div>
  <div
    class="p-5 flex flex-col bg-white border-solid"
    [class.border-[2px]]="item.isModerated"
    [class.border-[#e5cc6f]]="item.isModerated"
    [class.bg-[#fff8e0]]="item.isModerated"
  >
    <div class="flex">
      <img
        class="w-[50px] h-[50px] rounded object-cover"
        [src]="item?.images | first: 'thumb'"
      />
      <div class="text-slate-900 text-lg font-semibold leading-[21px] ml-5">
        {{ item.title }}
      </div>
    </div>
    <div class="flex justify-between items-center py-1">
      <div
        class="w-full h-[3px] bg-[#E6E1D7]"
        [class.bg-[#e5cc6f]]="item.isModerated"
      ></div>
      <div class="pl-[5px]" *ngIf="!item.isModerated">
        <div
          class="text-stone-400 text-[11px] font-bold uppercase leading-[18px] tracking-wide w-[40px]"
        >
          Reply
        </div>
      </div>

      <div class="pl-[5px]" *ngIf="item.isModerated">
        <div
          class="text-[#e5cc6f] text-[11px] font-bold uppercase leading-[18px] tracking-wide w-[140px]"
        >
          Reply in moderation
        </div>
      </div>
    </div>

    <div class="flex items-center">
      <div class="text-slate-900 text-base font-normal leading-relaxed">
        &#64;{{ item.creatorNickname }}
      </div>
      <div class="text-stone-400 text-sm font-normal leading-normal ml-4">
        1w
      </div>
    </div>

    <div
      class="text-[#636363] text-base font-normal leading-[21px] mt-3 line-clamp-3"
      [innerHTML]="item.description | links"
    ></div>

    <!-- <div *ngIf="item.isModerated" class="flex items-center justify-end my-3">
      <ark-lib-icon-name name="gavel"></ark-lib-icon-name>
      <div class="text-slate-900 text-sm font-semibold leading-normal ml-[5px]">
        Moderate (0.001 pts)
      </div>
    </div> -->

    <div
      class="flex flex-row justify-between mt-3"
      [class.opacity-40]="item.isModerated"
      [class.pointer-events-none]="item.isModerated"
    >
      <div class="flex flex-row items-center">
        <ark-lib-icon-name name="stats"></ark-lib-icon-name>
        <div class="text-black text-[11px] font-normal leading-[18px] ml-[5px]">
          {{ item.receivedCount }}
        </div>
      </div>

      <div class="flex flex-row items-center">
        <ark-lib-icon-name name="like"></ark-lib-icon-name>
        <div class="text-black text-[11px] font-normal leading-[18px] mx-[5px]">
          {{ item.upVoteCount| numberAbbrevation }}
        </div>
        <ark-lib-icon-name name="dislike"></ark-lib-icon-name>
        <!-- <div class="text-black text-[11px] font-normal leading-[18px] mx-[5px]">
          {{ item.downVoteCount| numberAbbrevation }}
        </div> -->
      </div>

      <div class="flex flex-row items-center">
        <ark-lib-icon-name name="chat"></ark-lib-icon-name>
        <div class="text-black text-[11px] font-normal leading-[18px] ml-[5px]">
          {{ item.commentCount }}
        </div>
      </div>

      <div class="flex flex-row items-center">
        <ark-lib-proposition-menu
          [options]="menuOptions"
        ></ark-lib-proposition-menu>
      </div>
    </div>
  </div>
</div>
